import React from 'react';
import { Box, Typography, Button, Paper, Container } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

interface LocationState {
  serviceName?: string;
  requiredGroup?: string;
  message?: string;
}

const AccessDenied: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state as LocationState) || {};
  
  const serviceName = state.serviceName || 'this service';
  const requiredGroup = state.requiredGroup || 'the appropriate Azure AD group';
  const message = state.message || `You don't have permission to access ${serviceName}.`;

  return (
    <Container maxWidth="md">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="80vh"
      >
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: 'center',
            maxWidth: 600,
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mb: 3,
            }}
          >
            <LockIcon
              sx={{
                fontSize: 80,
                color: 'error.main',
              }}
            />
          </Box>

          <Typography variant="h4" gutterBottom fontWeight="bold">
            Access Denied
          </Typography>

          <Typography variant="body1" color="text.secondary" paragraph>
            {message}
          </Typography>

          <Box
            sx={{
              backgroundColor: 'grey.100',
              borderRadius: 1,
              padding: 2,
              my: 3,
              textAlign: 'left',
            }}
          >
            <Typography variant="subtitle2" gutterBottom fontWeight="bold">
              Required Access:
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {requiredGroup}
            </Typography>
          </Box>

          <Typography variant="body2" color="text.secondary" paragraph>
            If you believe you should have access to this service, please contact your
            administrator to be added to {requiredGroup}.
          </Typography>

          <Box sx={{ mt: 3, display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate('/getting-started')}
            >
              Go to Getting Started
            </Button>
            <Button
              variant="outlined"
              onClick={() => navigate(-1)}
            >
              Go Back
            </Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default AccessDenied;
